var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-view", {
                attrs: { title: _vm.$t("message.faq.title"), icon: "ti-help" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0 mt-3" },
        [
          _c(
            "h4",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion1",
                      modifiers: { accordion1: true }
                    }
                  ],
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "accordion1"
                  }
                },
                [_c("h4", [_vm._v("Trauer - Was ist das?")])]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "float-right" },
                [
                  _c("b-button", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.accordion1",
                        modifiers: { accordion1: true }
                      }
                    ],
                    staticClass: "btn-link",
                    attrs: {
                      size: "md",
                      variant: "link",
                      "aria-controls": "accordion1"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "pl-2 pr-2" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text1_0) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 text-left" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion1",
                      modifiers: { accordion1: true }
                    }
                  ],
                  staticClass: "btn-primary rounded-0 weiter",
                  attrs: {
                    size: "md",
                    variant: "primary",
                    "aria-controls": "accordion1"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.faq.collapse")) + "\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-0",
              attrs: { id: "accordion1", accordion: "my-accordion" }
            },
            [
              _c("b-table", { attrs: { striped: "", responsive: "" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetrauer1",
                          modifiers: { collapsetrauer1: true }
                        }
                      ],
                      staticClass: " rounded-0 col-lg-12 text-left mt-2",
                      attrs: { variant: "light" }
                    },
                    [_vm._v(" Was ist\n          Trauer\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetrauer1" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text1_1) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetrauer2",
                          modifiers: { collapsetrauer2: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        " Trauerplan und\n          Traueraufgabe?\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetrauer2" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text1_2) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetrauer3",
                          modifiers: { collapsetrauer3: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        " Trauer bei\n          Kindern und Jugendlichen\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetrauer3" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text1_3) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetrauer4",
                          modifiers: { collapsetrauer4: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v(" Gedankenräume\n          im Internet\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetrauer4" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text1_4) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0 mt-2" },
        [
          _c(
            "h4",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion2",
                      modifiers: { accordion2: true }
                    }
                  ],
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "accordion2"
                  }
                },
                [_c("h4", [_vm._v("Der Todesfall - was ist zu tun?")])]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "float-right" },
                [
                  _c("b-button", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.accordion2",
                        modifiers: { accordion2: true }
                      }
                    ],
                    staticClass: "btn-link",
                    attrs: {
                      size: "md",
                      variant: "link",
                      "aria-controls": "accordion2"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "pl-2 pb-0 mb-0 text-left" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text2) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 text-left" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion2",
                      modifiers: { accordion2: true }
                    }
                  ],
                  staticClass: "btn-primary rounded-0 weiter",
                  attrs: {
                    size: "md",
                    variant: "primary",
                    "aria-controls": "accordion2"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("message.faq.collapse")) + "\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "mt-0",
              attrs: { id: "accordion2", accordion: "my-accordion" }
            },
            [
              _c("b-table", { attrs: { striped: "", responsive: "" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesfall1",
                          modifiers: { collapsetodesfall1: true }
                        }
                      ],
                      staticClass: " rounded-0  col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v(" 1. Arzt\n          benachrichtigen\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesfall1" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text2_1) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesfall2",
                          modifiers: { collapsetodesfall2: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "2. Bestatter\n          benachrichtigen\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesfall2" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text2_2) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesfall3",
                          modifiers: { collapsetodesfall3: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "3. Wichtige\n          Dokumente im Trauerfall\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesfall3" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text2_3) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesfall4",
                          modifiers: { collapsetodesfall4: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "4. Erledigung\n          der Formalitäten\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesfall4" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text2_4) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0 mt-2" },
        [
          _c(
            "h4",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion3",
                      modifiers: { accordion3: true }
                    }
                  ],
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "accordion3"
                  }
                },
                [_c("h4", [_vm._v("Formen der Bestattung")])]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "float-right" },
                [
                  _c("b-button", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.accordion3",
                        modifiers: { accordion3: true }
                      }
                    ],
                    staticClass: "btn-link",
                    attrs: {
                      size: "md",
                      variant: "link",
                      "aria-controls": "accordion3"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "pl-2 text-left" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text3_0) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 text-left" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion3",
                      modifiers: { accordion3: true }
                    }
                  ],
                  staticClass: "btn-primary rounded-0 weiter",
                  attrs: {
                    size: "md",
                    variant: "primary",
                    "aria-controls": "accordion3"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.faq.collapse")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "accordion3", accordion: "my-accordion" } },
            [
              _c("b-table", { attrs: { striped: "", responsive: "" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebestattung1",
                          modifiers: { collapsebestattung1: true }
                        }
                      ],
                      staticClass: " rounded-0  col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v(" Erde, Feuer,\n          Wasser\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebestattung1" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text3_1) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebestattung2",
                          modifiers: { collapsebestattung2: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("\n          Feuerbestattung\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebestattung2" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text3_2) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebestattung3",
                          modifiers: { collapsebestattung3: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("\n          Seebestattung\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebestattung3" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text3_3) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebestattung4",
                          modifiers: { collapsebestattung4: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("Sonderformen\n          der Bestattung\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebestattung4" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text3_4) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebestattung5",
                          modifiers: { collapsebestattung5: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("\n          Preisgestaltung\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebestattung5" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text3_5) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0 mt-2" },
        [
          _c(
            "h4",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion4",
                      modifiers: { accordion4: true }
                    }
                  ],
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "accordion4"
                  }
                },
                [_c("h4", [_vm._v("Todesanzeigen")])]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "float-right" },
                [
                  _c("b-button", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.accordion4",
                        modifiers: { accordion4: true }
                      }
                    ],
                    staticClass: "btn-link",
                    attrs: {
                      size: "md",
                      variant: "link",
                      "aria-controls": "accordion4"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "pl-2 text-left" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text4_0) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 text-left" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion4",
                      modifiers: { accordion4: true }
                    }
                  ],
                  staticClass: "btn-primary rounded-0 weiter",
                  attrs: {
                    size: "md",
                    variant: "primary",
                    "aria-controls": "accordion4"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.faq.collapse")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "accordion4", accordion: "my-accordion" } },
            [
              _c("b-table", { attrs: { striped: "", responsive: "" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesanzeige1",
                          modifiers: { collapsetodesanzeige1: true }
                        }
                      ],
                      staticClass: " rounded-0  col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        " Was sollten\n          sie unbedingt beachten?\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesanzeige1" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text4_1) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesanzeige2",
                          modifiers: { collapsetodesanzeige2: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("Statt\n          besonderer Anzeige\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesanzeige2" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text4_2) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesanzeige3",
                          modifiers: { collapsetodesanzeige3: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("Die Bitte\n          um eine Spende\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesanzeige3" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text4_3) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsetodesanzeige4",
                          modifiers: { collapsetodesanzeige4: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [_vm._v("\n          Danksagungen\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsetodesanzeige4" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text4_4) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card",
        { staticClass: "rounded-0 mt-2" },
        [
          _c(
            "h4",
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion5",
                      modifiers: { accordion5: true }
                    }
                  ],
                  staticClass: "btn-link",
                  attrs: {
                    size: "md",
                    variant: "link",
                    "aria-controls": "accordion5"
                  }
                },
                [_c("h4", [_vm._v("Beileidsbekundungen")])]
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "float-right" },
                [
                  _c("b-button", {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.accordion5",
                        modifiers: { accordion5: true }
                      }
                    ],
                    staticClass: "btn-link",
                    attrs: {
                      size: "md",
                      variant: "link",
                      "aria-controls": "accordion5"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("p", { staticClass: "pl-2 text-left" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.text5_0) } })
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pt-3 text-left" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.accordion5",
                      modifiers: { accordion5: true }
                    }
                  ],
                  staticClass: "btn-primary rounded-0 weiter ",
                  attrs: {
                    size: "md",
                    variant: "primary",
                    "aria-controls": "accordion5"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.faq.collapse")) + "\n      "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            { attrs: { id: "accordion5", accordion: "my-accordion" } },
            [
              _c("b-table", { attrs: { striped: "", responsive: "" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-left" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid1",
                          modifiers: { collapsebeileid1: true }
                        }
                      ],
                      staticClass: " rounded-0  col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        " Trauerfall im\n          Kreis der Familie\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid1" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_1) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid2",
                          modifiers: { collapsebeileid2: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall nach\n          glücklichem und erfülltem Leben\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid2" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_2) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid3",
                          modifiers: { collapsebeileid3: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Vorlage für\n          Trauerfall im Bekanntenkreis\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid3" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_3) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid4",
                          modifiers: { collapsebeileid4: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall bei\n          flüchtig bekannten Personen\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid4" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_4) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid5",
                          modifiers: { collapsebeileid5: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall im\n          beruflichen Umfeld\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid5" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_5) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid6",
                          modifiers: { collapsebeileid6: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall in\n          extremen Situationen (Kind)\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid6" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_6) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid7",
                          modifiers: { collapsebeileid7: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall in\n          extremen Situationen (Selbsttötung)\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid7" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_7) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid8",
                          modifiers: { collapsebeileid8: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall in\n          extremen Situationen (Unfall)\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid8" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_8) }
                        })
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-toggle",
                          rawName: "v-b-toggle.collapsebeileid9",
                          modifiers: { collapsebeileid9: true }
                        }
                      ],
                      staticClass: " rounded-0 mt-2 col-lg-12 text-left",
                      attrs: { variant: "light" }
                    },
                    [
                      _vm._v(
                        "Trauerfall in\n          extremen Situationen (Verbrechen)\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-collapse",
                    {
                      staticClass: "mt-2 rounded-0",
                      attrs: { id: "collapsebeileid9" }
                    },
                    [
                      _c("b-card", { staticClass: "rounded-0" }, [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.text5_9) }
                        })
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-144787a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144787a5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/info/Faq.vue
// module id = 2zqy
// module chunks = 1